import * as React from 'react';
import { observer } from 'mobx-react';
import { useStores } from '~store/utils';
import AnalyticsRangeControls from '~components/Analytics/AnalyticsRangeControls';
import GraphGrid from '~components/Analytics/GraphGrid';
import { useAnalyticsWindow } from '~components/Analytics/analyticsWindow';
import { ALERTS_GRAPHS } from '~components/Analytics/graphs';

export const AlertsTab: React.FC = observer(() => {
  const { sites } = useStores();
  const timeWindow = useAnalyticsWindow();
  const siteUuid = sites.selectedSite?.uuid;

  return (
    <>
      <AnalyticsRangeControls timeWindow={timeWindow} />
      {siteUuid && <GraphGrid graphs={ALERTS_GRAPHS} siteUuid={siteUuid} timeWindow={timeWindow} />}
    </>
  );
});
